"use client";
import { cn } from "@/lib/cn";
import React from "react";
import { BiLoaderAlt } from "react-icons/bi";

interface ButtonProps {
  label: string;
  onClick?: any;
  type: "button" | "submit" | "reset" | undefined;
  className?: string;
  isLoading: boolean;
}
const Button = ({
  label,
  onClick,
  type,
  className,
  isLoading = false,
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={!isLoading ? onClick : (e) => e.preventDefault()}
      className={cn(
        "py-2 px-6 bg-white text-sm flex items-center justify-center text-neutral-900 rounded-full hover:bg-white/90 transition-colors min-w-24",
        className
      )}
    >
      {isLoading ? <BiLoaderAlt className="animate-spin" size={20} /> : label}
    </button>
  );
};

export default Button;
